/* eslint-disable no-undef */
import { parseBoolean } from 'utils/storage';

const config = {
    ENABLE_GOOGLE_ANALYTICS_LOGGING: parseBoolean(process.env.ENABLE_GOOGLE_ANALYTICS_LOGGING),
    ENABLE_COOKIEYES: parseBoolean(process.env.ENABLE_COOKIEYES),
    ENABLE_SENTRY: parseBoolean(process.env.ENABLE_SENTRY),
    DEBUG: parseBoolean(process.env.DEBUG),
    API_URL: process.env.API_URL,
    GOOGLE_ANALYTICS_ID: process.env.GOOGLE_ANALYTICS_ID,
    COOKIEYES_ID: process.env.COOKIEYES_ID,
    STORAGE_TOKEN_KEY: '_userToken',
}

if (config.DEBUG) {
    window.config = config
}

export default config;